import { render, staticRenderFns } from "./SchoolContactForm.vue?vue&type=template&id=4f269f5c&scoped=true&"
import script from "./SchoolContactForm.vue?vue&type=script&lang=js&"
export * from "./SchoolContactForm.vue?vue&type=script&lang=js&"
import style0 from "./SchoolContactForm.vue?vue&type=style&index=0&id=4f269f5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f269f5c",
  null
  
)

export default component.exports